import React from "react";
import {connect} from "react-redux";

import SvgIcon from "@mui/material/SvgIcon";

import LoadingSpinner from "../../ui/loadingSpinner";
import {GroheDownloadIcon} from "../../common/icons";


const UiPopupAIContentResult = (props) => {

  const {aiLoading, aiResults} = props;

  return (
    <div className="mb-1">
      {aiLoading ? <LoadingSpinner size=" message-loading-left-panel-spinner message-loading-left-panel-spinner--30 h-2 w-2"/> : null}
      {aiResults.map(aiResult => {
        if (!aiResult.resultImageUrl) {
          return null;
        }
        return (
          <div key={aiResult.resultImageUrl}>
            {aiResult.resultImageUrl ?
              <div className="mb-05">
                <a className="link link--blue flex--center" style={{display: "inline-flex", borderBottom: "1px dashed"}}
                   href={aiResult.resultImageUrl} rel="noopener noreferrer" target="_blank">
                  <SvgIcon>
                    <GroheDownloadIcon/>
                  </SvgIcon>
                  <span className="pl-05">Download Image</span>
                </a>
              </div> : null}
            {aiResult.firstPrompt ? (
              <div className="mb-05 text-left">
                <span className="mb-05 block color-primary bold">First Prompt</span>
                <p className="secondary">{aiResult.firstPrompt}</p>
              </div>
            ) : null}
            {aiResult.secondPrompt ? (
              <div className="mb-05 text-left">
                <span className="mb-05 block color-primary bold">Second Prompt</span>
                <p className="secondary">{aiResult.secondPrompt}</p>
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiLoading, aiResults} = store.aiState;

  return {
    aiLoading,
    aiResults,
  };
};

export default connect(mapStateToProps)(UiPopupAIContentResult)

